import { ChangeDetectionStrategy, Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { TabsModuleBase } from '../../../utilities/tabs/tabs-module-base';
import { FiStateNames } from '../../../shared/fi-state-proxy/fi-state-names';
import { AppTextService } from '../../../shared/app-text';

@Component({
    selector: 'pk-edit-container',
    template: `
        <div class="fi-container">
            <div class="fi-header">
                <div class="fi-header-actions">
                    <fi-button-back-new></fi-button-back-new>
                </div>
                <div class="fi-header-text">
                    {{ 'pk.personalkollen' | fiAppText }}
                </div>
                <fi-tabs
                    [tabsModel]="tabs"
                    [selectedIndex]="selectedIndex"
                    (selectedIndexChange)="onTabIndexChange($event)"
                >
                </fi-tabs>
            </div>
            <div class="fi-content ExtraLightBackgroundColor">
                <ui-view></ui-view>
            </div>
        </div>
    `,
    styleUrls: ['./pk-edit-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'pk-edit-container' },
    standalone: false,
})
export class PkEditContainerComponent extends TabsModuleBase implements OnInit {
    constructor(
        injector: Injector,
        private appTextService: AppTextService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.tabs.push({
            Title: this.appTextService.get('settings'),
            Sref: FiStateNames.OtherSettings.PK.Settings,
        });

        this.tabs.push({
            Title: this.appTextService.get('pk.match_roles'),
            Sref: FiStateNames.OtherSettings.PK.RolesMatching,
        });

        this.tabs.push({
            Title: this.appTextService.get('pk.match_units'),
            Sref: FiStateNames.OtherSettings.PK.UnitsMatching,
        });

        this.tabs.push({
            Title: this.appTextService.get('pk.user_import'),
            Sref: FiStateNames.OtherSettings.PK.UserImport,
        });

        this.tabs.push({
            Title: this.appTextService.get('pk.match_users'),
            Sref: FiStateNames.OtherSettings.PK.UsersMatching,
        });

        this.tabs.push({
            Title: this.appTextService.get('pk.import_log'),
            Sref: FiStateNames.OtherSettings.PK.ImportLog,
        });

        super.updateSelectedTabFromState();
    }
}
